import React from 'react';
import { NextPage } from 'next';
import { AxiosResponse } from 'axios';
import { GetPostFeedAPI } from 'api/community';
import { SubHeaderOptions } from 'constants/index';
import SubHeader from 'components/common/SubHeader';
import { communityActions } from 'store/community';
import SpaceFeedDetailService from 'components/branch/_post_detail';

interface IProps {
  error: boolean;
}

const SpaceFeed: NextPage<IProps> = ({ error }: IProps) => {
  if (error) {
    return null;
  }

  return (
    <>
      <SubHeader options={SubHeaderOptions} selected="소식" />
      <SpaceFeedDetailService />
    </>
  );
};

SpaceFeed.getInitialProps = async ({ query, store }) => {
  const { id } = query;

  const response: AxiosResponse = await GetPostFeedAPI(id);

  if (response.status >= 400) {
    return { error: true };
  }

  store.dispatch(communityActions.setBranchPost(response.data));

  return {
    error: false,
  };
};

export default SpaceFeed;
